import { CurrencyReport } from '../../hoc/currency-position/types';
import formatReportBalance from '../../hoc/helpers/format-report-balance';

import cn from './currencies-position.module.css';

const CurrenciesPositionItem = ({
  currencyReport,
}: {
  currencyReport: CurrencyReport;
}) => (
  <div className={cn.currenciesPositionItem}>
    <div className={cn.currenciesPositionValue}>
      {currencyReport.currency.name}
    </div>
    <div
      className={`${cn.currenciesPositionValue} ${
        currencyReport.short ? cn.currenciesPositionValueShort : ''
      }`}
    >
      {currencyReport?.short?.toString() &&
      (currencyReport.short !== undefined || currencyReport.short !== null)
        ? formatReportBalance(currencyReport.short)
        : '-'}
    </div>
    <div className={cn.currenciesPositionValue}>
      {currencyReport?.long?.toString() &&
      (currencyReport.long !== undefined || currencyReport.long !== null)
        ? formatReportBalance(currencyReport.long)
        : '-'}
    </div>
  </div>
);

export default CurrenciesPositionItem;
